/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    import ILocation = DealerwareWebServices.ILocation;

    export class LocationAddressFormDirectiveController {

        public static $inject : string[] = [
            '$scope',
            '$timeout',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'NgMap'
        ];

        public location: ILocation;
        public mapConfig: any;
        public mapCenter: any;
        public mapZoom: any;
        public mapMarkers: any;

        constructor(public $scope: any,
                    public $timeout: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public NgMap: any) {
            var _self = this;

            this.mapConfig = {
                infoWindowTemplate: '/components/location/location-address-info-window.html',
                scrollToZoom: true
            };

            this.$scope.$watch(() => {
                return _self.location;
            }, (location: any) => {
                _self.$timeout(() => {
                    if (location && _self.location.showMap) {
                        _self.location.showMap = false;

                        if (_self.hasLatLng()) {
                            _self.mapCenter = { lat: location.latitude, lng: location.longitude };
                            _self.mapMarkers = [{ data: this.location }];
                            _self.mapZoom = 15;
                        } else {
                            _self.geocodeAddress(_self.location);
                        }

                        _self.NgMap.getMap('location-map').then((map: any) => {
                            google.maps.event.trigger(map, 'resize');
                            google.maps.event.addListener(map, 'click', (e: any) => {
                                _self.setPosition(e);
                            });
                        });
                    }
                }, 100);
            }, true);
        }

        public hasLatLng() : boolean {
            return this.location && !!this.location.latitude && !!this.location.longitude;
        }

        public setDefaultMapPosition() : void {
            // Centers map on the geographic center of the contiguous US
            this.mapCenter = { lat: 39.8282, lng: -98.5795 };
            this.mapZoom = 5;
        }

        public geocodeAddress(loc: ILocation) : void {
            var _self = this;

            if (!!loc.line1 && !!loc.city && !!loc.state && !!loc.zip) {
                this.NgMap.getGeoLocation(loc.line1 + ',' +
                                          loc.city + ',' +
                                          loc.state + ',' +
                                          loc.zip).then((r: any) => {
                    _self.mapCenter = { lat: r.lat(), lng: r.lng() };
                    _self.mapZoom = 15;
                }, () => {
                    _self.setDefaultMapPosition();
                });
            } else {
                _self.setDefaultMapPosition();
            }
        }

        public setPosition(e: any) : void {
            this.$scope.locationAddressForm.latitude.$setViewValue(0);
            this.$scope.locationAddressForm.longitude.$setViewValue(0);
            this.location.latitude = e.latLng.lat().toFixed(6);
            this.location.longitude = e.latLng.lng().toFixed(6);
            this.$scope.locationAddressForm.$setDirty();
            this.mapMarkers = [{ data: this.location }];
        }

        public save() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.location.save().then((location: ILocation) => {
                _self.location = location;
                loader.close();
                _self.$dealerwareNotification.toast('Location saved');
            }).catch((response: any) => {
                _self.$dealerwareNotification.apiError(response);
            });
        }

        public isSaveDisabled () : boolean {
            if (this.$scope.locationAddressForm && this.location) {
                return (this.$scope.locationAddressForm.$invalid
                        || this.$scope.locationAddressForm.$pristine
                        || this.location.isLocationExistingOrUnchanged());
            }

            return true;
        }
    }

    getDealerwareWebComponentsModule().controller('LocationAddressFormDirectiveController', LocationAddressFormDirectiveController);


    export class LocationAddressFormDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'LocationAddressFormDirectiveController';
        public controllerAs     : string    =   'locationAddressController';
        public bindToController : boolean   =   true;
        public scope            : Object    =   { location: '=' }
        public templateUrl      : string    =   '/components/location/location-address-form-directive.html';
    }

    getDealerwareWebComponentsModule().directive("dealerwareLocationAddressForm",() => new LocationAddressFormDirective());
}
